import { takeLatest, call, put, all } from "redux-saga/effects";
import * as types from "./types";
import api from "app/services/api";
import ToastService from "../../../services/ToastService";
import { setDeviceModelsData } from "./actions";
import objectToQueryString from "app/utils/objectToQueryString";

export function* create({ payload }) {
  const { formData, callback } = payload;
  try {
    yield put({
      type: types.CREATE,
    });
    yield call(api.post, "/device-type-models", formData);
    yield put({
      type: types.CREATE_SUCCESS,
    });
    ToastService.showSuccess("deviceModels.successCreate");
    callback();
  } catch (error) {
    ToastService.showError("Erro ao cadastrar modelo de dispositivo");
    yield put({
      type: types.CREATE_FAIL,
    });
  }
}

export function* read({ payload }) {
  try {
    yield put({
      type: types.READ,
    });
    const { data } = yield call(api.get, 
      `/device-type-models${objectToQueryString(payload)}`
    );
    yield put(setDeviceModelsData(data));
    yield put({
      type: types.READ_SUCCESS,
    });
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.READ_FAIL,
    });
  }
}

export function* update({ payload }) {
  const { id, formData, callback } = payload;
  try {
    yield put({
      type: types.UPDATE,
    });
    yield call(api.put, `/device-type-models/${id}`, formData);
    yield put({
      type: types.UPDATE_SUCCESS,
    });
    ToastService.showSuccess("deviceModels.successUpdate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.UPDATE_FAIL,
    });
  }
}

export function* inactivate({ payload }) {
  const { id, callback } = payload;
  try {
    yield put({
      type: types.DELETE,
    });
    yield call(api.delete, `/device-type-models/${id}`);
    yield put({
      type: types.DELETE_SUCCESS,
    });
    ToastService.showSuccess("deviceModels.successInactivate");
    callback();
  } catch (error) {
    yield put({
      type: types.DELETE_FAIL,
    });
    ToastService.showApiRequestError(error);
    callback();
  }
}

export default all([
  takeLatest(types.REQUEST_CREATE, create),
  takeLatest(types.REQUEST_READ, read),
  takeLatest(types.REQUEST_UPDATE, update),
  takeLatest(types.REQUEST_DELETE, inactivate),
]);
